import type { CareStateProblemT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { Card, TruncatedMarkdown } from '@/shared/ui/primitives';

export interface ProblemListCardProps {
  problem: CareStateProblemT;
}

export function ProblemListCard({ problem }: ProblemListCardProps) {
  const note = problem.note?.value ?? '';
  const hasNote = note.trim().length > 0;

  return (
    <Card tone="default" aria-label={problem.title}>
      <h3 className="text-base font-medium text-foreground">{problem.title}</h3>
      {hasNote ? (
        <TruncatedMarkdown id={`problem-${problem.id}-note`} content={note} />
      ) : (
        <p className="text-sm text-muted-foreground">No note yet.</p>
      )}
    </Card>
  );
}
